export const createIsHighlighted = (highlightScope, highlightedItem) => item => {
  if (!highlightScope || !highlightedItem || !item) {
    return false;
  }
  if (highlightScope.highlight === 'series') {
    return item.seriesId === highlightedItem.seriesId;
  }
  if (highlightScope.highlight === 'item') {
    return item.dataIndex === highlightedItem.dataIndex && item.seriesId === highlightedItem.seriesId;
  }
  return false;
};